export const formatBytes = (bytes: number, decimals = 2): number => {
  const k = 1000000; // bytes in one MB
  const dm = decimals < 0 ? 0 : decimals;

  return parseFloat((bytes / k).toFixed(dm));
};
